export class CmsBlock {
    id:number;
    key:string;
    html:string;
    orderIdx:number;
    background:boolean;
    active:boolean;
}